import { Page } from "containers/Page";
import { FormFiltrarFornecedor } from "./containers/FormFiltrarFornecedor";
import { useEffect, useState } from "react";
import { ListarFornecedores } from "./containers/ListarFornecedores";
import { useFornecedores } from "./hooks/useFornecedores";
import { IFornecedorPJ, IFornecedorPF } from "./interfaces/IFornecedor";
import { toastErro } from "components/Toast";
import { IFiltro } from "./interfaces/IFiltro";
import { BodyAcaoFornecedor } from "./containers/BodyAcaoFornecedor";
import usePermissoes from "hooks/usePermissoes";

export function Fornecedor() {
  const {
    dados,
    error,
    setPage,
    setLimit,
    totalRows,
    loading,
    setLoading,
    listar,
    listarTodos,
    page,
    limit,
    setDados,
    dadosFornecedorEscolhido,
    setDadosFornecedorEscolhido,
    atualizar,
    ativacao,
    filtro,
    setFiltro,
    optionsFornecedores,
    gerarOptionsFornecedores,
    buscar,
    inserir,
    inserirDescricaoProcessoFinanceiroFornecedor,
    atualizarDescricaoProcessoFinanceiroFornecedor,
    excluirDescricaoProcessoFinanceiroFornecedor,
    listarProcessoFinanceiroDescricao,
    optionsProcessoFinanceiroDescricao,
  } = useFornecedores();

  const [acaoFornecedor, setAcaoFornecedor] = useState<
    "VER" | "ATUALIZAR" | "LISTAR" | "CADASTRAR"
  >("LISTAR");
  const { carregado, erroPermissoes, temPermissao } = usePermissoes();
  const showListagem = temPermissao("listar_fornecedores");

  useEffect(() => {
    if (error && error.hasErro) return toastErro(`${error.data.message}`);
  }, [error]);

  useEffect(() => {
    listar(filtro);
    gerarOptionsFornecedores();
    listarProcessoFinanceiroDescricao();
  }, [page, limit, filtro]);

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handleLimitChange = (limit: number) => {
    setLimit(limit);
  };

  const handleAtualizarFornecedor = async (idFornecedor: number) => {
    const { hasErro } = await buscar(idFornecedor);

    if (!hasErro) {
      setAcaoFornecedor("ATUALIZAR");
      return;
    }
  };

  const handleAtivacaoFornecedor = async (
    idFornecedor: number,
    checked: boolean
  ) => {
    const { hasErro } = await ativacao(idFornecedor, checked);

    if (!hasErro) {
      listar(filtro);
    }
  };

  const handleVisualizarFornecedor = async (idFornecedor: number) => {
    const { hasErro } = await buscar(idFornecedor);

    if (!hasErro) {
      setAcaoFornecedor("VER");
      return;
    }
  };

  const onSubmit = (dados: IFiltro) => {
    listar(dados);
  };

  const strategyBody = {
    VER: (
      <BodyAcaoFornecedor
        dados={dadosFornecedorEscolhido}
        acaoFornecedor={acaoFornecedor}
        setAcaoFornecedor={setAcaoFornecedor}
        inserirFornecedor={inserir}
        atualizarFornecedor={atualizar}
        listar={listar}
        filtro={filtro}
        inserirDescricaoProcessoFinanceiroFornecedor={
          inserirDescricaoProcessoFinanceiroFornecedor
        }
        atualizarDescricaoProcessoFinanceiroFornecedor={
          atualizarDescricaoProcessoFinanceiroFornecedor
        }
        excluirDescricaoProcessoFinanceiroFornecedor={
          excluirDescricaoProcessoFinanceiroFornecedor
        }
        optionsDescricaoProcessoFinanceiro={optionsProcessoFinanceiroDescricao}
        setLoading={setLoading}
      />
    ),
    ATUALIZAR: (
      <BodyAcaoFornecedor
        dados={dadosFornecedorEscolhido}
        acaoFornecedor={acaoFornecedor}
        setAcaoFornecedor={setAcaoFornecedor}
        inserirFornecedor={inserir}
        atualizarFornecedor={atualizar}
        listar={listar}
        filtro={filtro}
        inserirDescricaoProcessoFinanceiroFornecedor={
          inserirDescricaoProcessoFinanceiroFornecedor
        }
        atualizarDescricaoProcessoFinanceiroFornecedor={
          atualizarDescricaoProcessoFinanceiroFornecedor
        }
        excluirDescricaoProcessoFinanceiroFornecedor={
          excluirDescricaoProcessoFinanceiroFornecedor
        }
        optionsDescricaoProcessoFinanceiro={optionsProcessoFinanceiroDescricao}
        setLoading={setLoading}
      />
    ),
    LISTAR: showListagem ? (
      <>
        <FormFiltrarFornecedor
          onSubmit={onSubmit}
          optionsFornecedor={optionsFornecedores}
          optionsAtividadePrincipal={optionsProcessoFinanceiroDescricao}
          setFiltro={setFiltro}
          filtro={filtro}
        />
        <ListarFornecedores
          dados={dados}
          loading={loading}
          totalRows={totalRows}
          onChangeRowsPerPage={handleLimitChange}
          onChangePage={handlePageChange}
          rowsPerPage={limit}
          handleAtualizarFornecedor={handleAtualizarFornecedor}
          handleAtivacaoFornecedor={handleAtivacaoFornecedor}
          handleVisualizarFornecedor={handleVisualizarFornecedor}
          handleCadastrarFornecedor={() => setAcaoFornecedor("CADASTRAR")}
          acaoFornecedor={acaoFornecedor}
          buscarDadosPlanilha={() => listarTodos(filtro)}
        />
      </>
    ) : erroPermissoes ? (
      <p style={{ marginTop: "60px", textAlign: "center" }}>
        Erro ao carregar permissões. Recarregue a página.
      </p>
    ) : (
      carregado && (
        <p style={{ marginTop: "60px", textAlign: "center" }}>
          Você não possui permissão para listar fornecedores.
        </p>
      )
    ),
    CADASTRAR: (
      <BodyAcaoFornecedor
        dados={null}
        acaoFornecedor={acaoFornecedor}
        setAcaoFornecedor={setAcaoFornecedor}
        inserirFornecedor={inserir}
        atualizarFornecedor={atualizar}
        listar={listar}
        filtro={filtro}
        inserirDescricaoProcessoFinanceiroFornecedor={
          inserirDescricaoProcessoFinanceiroFornecedor
        }
        atualizarDescricaoProcessoFinanceiroFornecedor={
          atualizarDescricaoProcessoFinanceiroFornecedor
        }
        excluirDescricaoProcessoFinanceiroFornecedor={
          excluirDescricaoProcessoFinanceiroFornecedor
        }
        optionsDescricaoProcessoFinanceiro={optionsProcessoFinanceiroDescricao}
        setLoading={setLoading}
      />
    ),
  };

  const strategyTitulo = {
    VER: "Cadastro fornecedor",
    ATUALIZAR: "Cadastro fornecedor",
    LISTAR: "Fornecedores",
    CADASTRAR: "Cadastrar fornecedor",
  };

  return (
    <Page title={strategyTitulo[acaoFornecedor]}>
      {strategyBody[acaoFornecedor]}
    </Page>
  );
}
